// extracted by mini-css-extract-plugin
export default {"skills__list--item":"Skill_skills__list--item__uK+3N"};